import { combineReducers, createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";

import profile from "./profile/reducer";
import product from "./product/reducer";
import section from "./customSection/reducer";
import image from "./upload/reducer";
import comment from "./comment/reducer";
import order from "./order/reducer";
import brand from "./brand/reducer";
import priceList from "./priceList/reducer";
import categoryNews from "./categoryNews/reducer";
import news from "./news/reducer";
import flashSaleRedux from "./flashSale/reducer";
import nameCard from "./nameCard/reducer";
import branch from "./branch/reducer";

const rootReducer = combineReducers({
    profile,
    product,
    section,
    image,
    comment,
    order,
    brand,
    priceList,
    categoryNews,
    news,
    flashSaleRedux,
    nameCard,
    branch,
});

const store = createStore(rootReducer, applyMiddleware(thunk));
export default store;
